import { render, staticRenderFns } from "./InspectionRecordList.vue?vue&type=template&id=4f976bfe&"
import script from "./InspectionRecordList.vue?vue&type=script&lang=js&"
export * from "./InspectionRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports